import React, { useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';

const CustomNumericKeyboard = ({ onNumberClick, onDeleteClick }) => {
  const handleNumberClick = (number) => {
    onNumberClick(number);
  };

  const handleDeleteClick = () => {
    onDeleteClick();
  };

  return (
    <div>
      <button onClick={() => handleNumberClick(1)}>1</button>
      <button onClick={() => handleNumberClick(2)}>2</button>
      {/* 他の数字ボタン */}
      <button onClick={handleDeleteClick}>Delete</button>
    </div>
  );
};

const columns = [
  { field: 'id', headerName: 'ID', width: 70 },
  { field: 'name', headerName: 'Name', width: 150, editable: true },
  // 他のカラムの定義
];

const UiTest = () => {
    const [ rows, setRows] = useState([
        { id: 1, name: '' },
        { id: 2, name: '' },
        // 他の行のデータ
      ])
  const [activeCellId, setActiveCellId] = useState(null);
  const [showNumericKeyboard, setShowNumericKeyboard] = useState(false);

  const handleEditCellChange = ({ id, field, props }) => {
    const value = props.value;
    const updatedRows = rows.map((row) => {
      if (row.id === id) {
        return { ...row, [field]: value };
      }
      return row;
    });
  
    setRows(updatedRows);
  };
  

  const handleDeleteClick = () => {
    if (activeCellId !== null) {
      // セルの内容を削除するロジックを実装
    }
  };

  return (
    <div style={{ height: 400, width: '100%' }}>
      <DataGrid
        rows={rows}
        columns={columns}
        onCellClick={(params) => {
          setActiveCellId(params.id);
          setShowNumericKeyboard(true);
        }}
      />
      {showNumericKeyboard && (
        <CustomNumericKeyboard
          onDeleteClick={handleDeleteClick}
          onEditCellChange={handleEditCellChange}
        />
      )}
    </div>
  );
};

export default UiTest;
